import type { EComDataType } from '~/stores/cartStore/model';
import { getActionBarCrossSellAttributionForSku } from './getActionBarCrossSellAttributionForSku';
import {
  ACTION_BAR_CROSS_SELL_ECOM_SOURCE,
  type ActionBarCrossSellAttribution
} from './types';

function getPrimaryAttribution(
  items: ReadonlyArray<Record<string, unknown>>
): ActionBarCrossSellAttribution | undefined {
  for (const item of items) {
    const sku = String(item.item_id ?? '');
    if (!sku) {
      continue;
    }

    const attribution = getActionBarCrossSellAttributionForSku(sku);
    if (attribution) {
      return attribution;
    }
  }

  return undefined;
}

export function enrichEcommerceWithActionBarAttribution(
  ecommerce: EComDataType,
  source?: string
): EComDataType {
  const enrichedItems = ecommerce.items.map((item) => {
    const sku = String(item.item_id ?? '');
    const attribution = sku
      ? getActionBarCrossSellAttributionForSku(sku)
      : undefined;

    if (!attribution) {
      return item;
    }

    return {
      ...item,
      item_list_id: attribution.item_list_id,
      item_list_name: attribution.item_list_name,
      selected_via_action_bar: attribution.selected_via_action_bar,
      ab_session_id: attribution.ab_session_id,
      ab_category: attribution.ab_category,
      ab_result_position: attribution.ab_result_position,
      ab_main_product_sku: attribution.ab_main_product_sku
    };
  });

  const hasActionBarItems = enrichedItems.some(
    (item) => item.selected_via_action_bar === true
  );
  const primaryAttribution = getPrimaryAttribution(enrichedItems);
  const isActionBarSource =
    source === ACTION_BAR_CROSS_SELL_ECOM_SOURCE || hasActionBarItems;

  if (!isActionBarSource || !primaryAttribution) {
    return {
      ...ecommerce,
      items: enrichedItems
    };
  }

  return {
    ...ecommerce,
    ecom_source: ACTION_BAR_CROSS_SELL_ECOM_SOURCE,
    ab_session_id: primaryAttribution.ab_session_id,
    items: enrichedItems
  };
}
